// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"9":"eace61b9","98":"f860d703","113":"c4a58994","161":"98668da3","205":"1176a194","453":"377e44f4","641":"6d18235f","780":"bda0d60f","843":"558609b5","938":"73ee8541"}[chunkId] + ".chunk.js";
};